import { render } from "./ContextSection.vue?vue&type=template&id=03d80ca2"
import script from "./ContextSection.vue?vue&type=script&lang=js"
export * from "./ContextSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/context-section/ContextSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03d80ca2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03d80ca2', __exports__)) {
    api.reload('03d80ca2', __exports__)
  }
  
  module.hot.accept("./ContextSection.vue?vue&type=template&id=03d80ca2", () => {
    api.rerender('03d80ca2', render)
  })

}


export default __exports__